/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface ApiKey {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  isDeleted?: boolean;
  key?: string | null;
  ownerName?: string | null;
  /** @format uuid */
  partnerId?: string;
  partner?: Partner;
  isActive?: boolean;
  role?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
  claims?: Claim[] | null;
}

export interface ApiKeyResetResponse {
  key?: string | null;
}

export interface ApiKeyViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  ownerName?: string | null;
  /** @format uuid */
  partnerId?: string;
  isActive?: boolean;
  role?: string | null;
  /** @format date-time */
  lastUsedAt?: string | null;
}

export interface BaseResponse {
  message?: string | null;
  status?: boolean;
  data?: Record<string, any>;
}

export enum BulkMessageStatus {
  Pending = "Pending",
  Processing = "Processing",
  Completed = "Completed",
  Error = "Error",
}

export interface BulkSmsCreateModel {
  /** @minLength 1 */
  description: string;
  /** @minLength 1 */
  body: string;
  /** @format uuid */
  sender?: string | null;
  recipientLists?: CustomerMiniViewModel[] | null;
  recipientContacts?: CustomerMiniViewModel[] | null;
  /** @format uuid */
  template?: string | null;
  /** @format date-time */
  timeToSend?: string | null;
}

export interface BulkSmsMessageImportRequest {
  /**
   * The partner id to be used
   * @format uuid
   */
  partnerId?: string;
  /**
   * The document id to be used
   * @format uuid
   */
  docId?: string;
  externalReference?: string | null;
  message?: string | null;
  /** @format date-time */
  scheduledAt?: string | null;
  /** @format uuid */
  templateId?: string | null;
}

export interface BulkSmsMessagePreview {
  /** @format uuid */
  docId?: string;
  document?: DocViewModel;
  /** @format int32 */
  totalRecords?: number;
  errors?: ImportError[] | null;
  sample?: SmsMessageCreateModel[] | null;
}

export interface BulkSmsMessageViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  status?: BulkMessageStatus;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format int32 */
  totalRequests?: number;
  /** @format int32 */
  completedRequests?: number;
  /** @format int32 */
  successfulRequests?: number;
  /** @format int32 */
  failedRequests?: number;
  /** @format date-time */
  startedAt?: string | null;
  /** @format date-time */
  completedAt?: string | null;
  externalReference?: string | null;
  /** @format uuid */
  documentId?: string | null;
  document?: DocViewModel;
  /** @format uuid */
  errorDocumentId?: string | null;
  errorDocument?: DocViewModel;
  template?: TemplateViewModel;
  createdBy?: string | null;
  message?: string | null;
  createdByData?: ComboModel;
}

export interface BulkSmsMessageViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: BulkSmsMessageViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface BulkSmsResumeProcessingRequest {
  /** @format uuid */
  bulkSmsRequestId?: string;
  status?: MessageStatus[] | null;
}

export interface Claim {
  issuer?: string | null;
  originalIssuer?: string | null;
  properties?: Record<string, string>;
  subject?: ClaimsIdentity;
  type?: string | null;
  value?: string | null;
  valueType?: string | null;
}

export interface ClaimsIdentity {
  authenticationType?: string | null;
  isAuthenticated?: boolean;
  actor?: ClaimsIdentity;
  bootstrapContext?: any;
  claims?: Claim[] | null;
  label?: string | null;
  name?: string | null;
  nameClaimType?: string | null;
  roleClaimType?: string | null;
}

export interface ComboModel {
  id?: string | null;
  name?: string | null;
}

export interface CompanyInfo {
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export interface ContactMiniViewModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}

export enum CustomerCategory {
  Person = "Person",
  Company = "Company",
}

export interface CustomerContactImportRequest {
  /**
   * The partner id to be used
   * @format uuid
   */
  partnerId?: string;
  /**
   * The document id to be used
   * @format uuid
   */
  docId?: string;
  externalReference?: string | null;
  message?: string | null;
}

export interface CustomerContactPreview {
  /** @format uuid */
  docId?: string;
  document?: DocViewModel;
  /** @format int32 */
  totalRecords?: number;
  errors?: ImportError[] | null;
  sample?: CustomerMiniViewModel[] | null;
}

export interface CustomerCreateModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @format uuid */
  partnerId?: string | null;
  /** @format tel */
  primaryPhone?: string | null;
  /** @format tel */
  secondaryPhone?: string | null;
  /** @format email */
  primaryEmail?: string | null;
  /** @format email */
  secondaryEmail?: string | null;
  customerGroupIds?: string[] | null;
}

export enum CustomerEmailCategory {
  Personal = "Personal",
  Work = "Work",
  Other = "Other",
}

export interface CustomerEmailViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  category?: CustomerEmailCategory;
  /** @format uuid */
  customerId?: string;
  value?: string | null;
  isPrimary?: boolean;
  /** @format uuid */
  partnerId?: string | null;
}

export interface CustomerGroupCreateModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  isPublic?: boolean;
  /** @format uuid */
  partnerId?: string;
}

export interface CustomerGroupUpdateModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  isPublic?: boolean;
  /** @format uuid */
  partnerId?: string;
}

export interface CustomerGroupViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  name?: string | null;
  description?: string | null;
  color?: string | null;
  isPublic?: boolean;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  hasContacts?: boolean;
}

export interface CustomerMiniUpdateModel {
  customerIds?: string[] | null;
  customerGroupIds?: string[] | null;
}

export interface CustomerMiniViewModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  primaryPhone?: string | null;
  secondaryPhone?: string | null;
  primaryEmail?: string | null;
  secondaryEmail?: string | null;
  contactGroup?: string | null;
}

export enum CustomerPhoneCategory {
  Mobile = "Mobile",
  Office = "Office",
  Home = "Home",
  Fax = "Fax",
  Other = "Other",
}

export interface CustomerPhoneCreateModel {
  /** @format uuid */
  customerId?: string;
  category?: CustomerPhoneCategory;
  value?: string | null;
  isPrimary?: boolean;
  /** @format uuid */
  partnerId?: string;
}

export interface CustomerPhoneViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format uuid */
  customerId?: string;
  category?: CustomerPhoneCategory;
  value?: string | null;
  isPrimary?: boolean;
  /** @format uuid */
  partnerId?: string;
}

export interface CustomerTagViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format uuid */
  customerId?: string;
  value?: string | null;
}

export interface CustomerUpdateModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @minLength 1 */
  firstName: string;
  /** @minLength 1 */
  lastName: string;
  /** @format uuid */
  partnerId?: string | null;
  /** @format tel */
  primaryPhone?: string | null;
  secondaryPhone?: string | null;
  primaryEmail?: string | null;
  secondaryEmail?: string | null;
  customerGroupIds?: string[] | null;
}

export interface CustomerViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  firstName?: string | null;
  lastName?: string | null;
  fullName?: string | null;
  /** @format uuid */
  partnerId?: string | null;
  partner?: ComboModel;
  primaryPhone?: string | null;
  secondaryPhone?: string | null;
  primaryEmail?: string | null;
  secondaryEmail?: string | null;
  customerGroups?: ComboModel[] | null;
}

export interface CustomerViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: CustomerViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface DocViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  name?: string | null;
  contentType?: string | null;
  originalName?: string | null;
  description?: string | null;
  size?: string | null;
  /** @format uuid */
  partnerId?: string;
}

export interface ImportError {
  /** @format int32 */
  row?: number;
  /** @format int32 */
  col?: number;
  error?: string | null;
}

export interface ImportResponse {
  /** @format uuid */
  id?: string;
  status?: boolean;
  /** @format int64 */
  total?: number;
  message?: string | null;
  fileName?: string | null;
  fileSize?: string | null;
  filePath?: string | null;
  errors?: ImportError[] | null;
}

export enum IoTecPayCollectionStatus {
  Pending = "Pending",
  SentToVendor = "SentToVendor",
  Success = "Success",
  Failed = "Failed",
}

export interface IoTecPayCreditTopUpResponse {
  /** @format uuid */
  transactionId?: string;
  payer?: string | null;
  status?: IoTecPayCollectionStatus;
  currency?: string | null;
  /** @format double */
  amount?: number;
  statusCode?: string | null;
  statusMessage?: string | null;
  /** @format double */
  totalTransactionCharge?: number | null;
}

export enum MessageRecipientCategory {
  Contact = "Contact",
  Group = "Group",
}

export interface MessageRecipientViewModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  phoneNumber?: string | null;
  email?: string | null;
  category?: MessageRecipientCategory;
}

export enum MessageStatus {
  Pending = "Pending",
  Processing = "Processing",
  Sent = "Sent",
  Failed = "Failed",
  Scheduled = "Scheduled",
  SentToVendor = "SentToVendor",
  FailedDelivery = "FailedDelivery",
}

export interface NotFoundResult {
  /** @format int32 */
  statusCode?: number;
}

export interface OkResult {
  /** @format int32 */
  statusCode?: number;
}

export interface Partner {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  isDeleted?: boolean;
  active?: boolean;
  members?: PartnerMember[] | null;
  partnerIps?: PartnerIp[] | null;
  apiKey?: ApiKey;
  productSubscriptions?: ProductSubscription[] | null;
  /** @maxLength 100 */
  senderId?: string | null;
  /** @maxLength 100 */
  mtnSenderId?: string | null;
  /** @maxLength 100 */
  airtelSenderId?: string | null;
}

export interface PartnerCreateModel {
  /** @format uuid */
  id?: string;
  partnerIps: string[];
}

export interface PartnerIp {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  isDeleted?: boolean;
  ipAddress?: string | null;
  partner?: Partner;
  /** @format uuid */
  partnerId?: string;
}

export interface PartnerIpViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @minLength 1 */
  ipAddress: string;
}

export interface PartnerLinkModel {
  /** @format uuid */
  id?: string;
  /** @minLength 1 */
  clientId: string;
  partnerIps: string[];
}

export interface PartnerMember {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  isDeleted?: boolean;
  partner?: Partner;
  /** @format uuid */
  partnerId?: string;
  active?: boolean;
  roles?: string[] | null;
}

export interface PartnerMemberViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  partner?: ComboModel;
  person?: ContactMiniViewModel;
  /** @format uuid */
  partnerId?: string;
  roles?: string[] | null;
  active?: boolean | null;
}

export interface PartnerUpdateModel {
  /** @format uuid */
  id?: string;
  partnerIps: string[];
  active?: boolean;
  mtnSenderId?: string | null;
  airtelSenderId?: string | null;
  company?: CompanyInfo;
}

export interface PartnerViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  clientId?: string | null;
  name?: string | null;
  active?: boolean;
  company?: XContactModel;
  members?: PartnerMemberViewModel[] | null;
  partnerIps?: PartnerIpViewModel[] | null;
  apiKey?: ApiKeyViewModel;
  products?: ProductViewModel[] | null;
  mtnSenderId?: string | null;
  airtelSenderId?: string | null;
}

export interface PartnerConfigurationViewModel {
  partnerId?: string;
  skipInactiveMtnNumbers?: boolean;
  skipRecycledMtnNumbers?: boolean;
  mtnSenderId?: string | null;
  airtelSenderId?: string | null;
}

export enum ProductCategory {
  Sms = "Sms",
}

export interface ProductCreditsIoTecPayTopUpModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: ProductCategory;
  /** @format double */
  credits?: number;
  /** @format double */
  amountToPay?: number;
  /** @minLength 1 */
  memo: string;
  /**
   * @format tel
   * @minLength 1
   */
  mobileMoneyNumber: string;
}

export interface ProductCreditsManualTopUpModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: ProductCategory;
  /**
   * @format double
   * @min 1
   */
  credits?: number;
  /** @minLength 1 */
  memo: string;
}

export interface ProductCreditsUsageThreshold {
  /** @format double */
  seventyFivePercent?: number;
  /** @format double */
  fiftyPercent?: number;
  /** @format double */
  twentyFivePercent?: number;
}

export interface ProductCreditsWalletToWalletTopUpModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: ProductCategory;
  /** @format double */
  credits?: number;
  /** @format double */
  amountToPay?: number;
  /** @minLength 1 */
  memo: string;
  /** @minLength 1 */
  walletCode: string;
  walletPin?: string | null;
}

export enum ProductPaymentMethod {
  BankDeposit = "BankDeposit",
  MobileMoney = "MobileMoney",
  Free = "Free",
  IoTecWallet = "IoTecWallet",
}

export interface ProductPriceBand {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  isDeleted?: boolean;
  category?: ProductCategory;
  /** @maxLength 35 */
  name?: string | null;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
  /** @maxLength 3 */
  currency?: string | null;
  /** @maxLength 50 */
  createdBy?: string | null;
}

export interface ProductPriceBandCreateModel {
  /** @format uuid */
  productId?: string;
  /** @maxLength 35 */
  name?: string | null;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
}

export interface ProductPriceBandUpdateModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @maxLength 35 */
  name?: string | null;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
}

export interface ProductPriceBandViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  name?: string | null;
  /** @format int32 */
  lowerLimit?: number;
  /** @format int32 */
  upperLimit?: number | null;
  /** @format double */
  unitPrice?: number;
  /** @format double */
  purchasableCredits?: number;
  /** @format double */
  purchasableAmount?: number;
  category?: ProductCategory;
  currency?: string | null;
}

export enum ProductPurchaseOrderInvoiceStatus {
  Pending = "Pending",
  Paid = "Paid",
  Cancelled = "Cancelled",
}

export interface ProductPurchaseOrderInvoiceViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format uuid */
  partnerId?: string;
  productCategory?: ProductCategory;
  /** @format uuid */
  purchaseOrderId?: string;
  invoiceNumber?: string | null;
  status?: ProductPurchaseOrderInvoiceStatus;
  /** @format date-time */
  dueDate?: string | null;
  memo?: string | null;
  partnerAddress?: string | null;
  partnerEmail?: string | null;
  partnerPhone?: string | null;
  partnerName?: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  taxAmount?: number;
  /** @format double */
  credits?: number;
  /** @format double */
  unitPrice?: number;
  /** @format uuid */
  createdBy?: string;
  /** @format uuid */
  updatedBy?: string | null;
}

export interface ProductPurchaseOrderIoTecPayViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  category?: string | null;
  currency?: string | null;
  walletId?: string | null;
  externalId?: string | null;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  payer?: string | null;
  payerNote?: string | null;
  /** @format double */
  amount?: number;
  payeeNote?: string | null;
  channel?: string | null;
  transactionChargesCategory?: string | null;
  productCategory?: ProductCategory;
  status?: IoTecPayCollectionStatus;
  /** @format double */
  credits?: number;
  /** @format double */
  totalAmountPaid?: number;
  /** @format double */
  transactionCharge?: number;
  /** @format double */
  vendorCharge?: number;
  /** @format double */
  totalTransactionCharge?: number;
  payerName?: string | null;
  createdBy?: string | null;
  /** @format uuid */
  purchaseOrderId?: string;
}

export interface ProductPurchaseOrderPreviewRequestModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: ProductCategory;
  /** @format double */
  credits?: number;
  paymentMethod?: ProductPaymentMethod;
  /** Added for mobile money payment method. */
  mobileMoneyNumber?: string | null;
  /** Added for iotec wallet payment method */
  walletCode?: string | null;
  /** Added for iotec wallet payment method */
  walletPin?: string | null;
}

export interface ProductPurchaseOrderPreviewResponseModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: ProductCategory;
  /** @format double */
  credits?: number;
  paymentMethod?: ProductPaymentMethod;
  /** @format double */
  amount?: number;
  /** @format double */
  transactionCharges?: number;
  /** Added for mobile money payment method. */
  mobileMoneyNumber?: string | null;
  /** Added for wallet code payment method. */
  walletCode?: string | null;
  /** Added for wallet code payment method. */
  walletPin?: string | null;
}

export enum ProductPurchaseOrderStatus {
  Pending = "Pending",
  Paid = "Paid",
  Cancelled = "Cancelled",
}

export interface ProductPurchaseOrderViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  productCategory?: ProductCategory;
  paymentMethod?: ProductPaymentMethod;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format uuid */
  requestId?: string;
  memo?: string | null;
  /** @format double */
  amount?: number;
  vatCharge?: number;
  /** @format double */
  credits?: number;
  /** @format uuid */
  purchaseOrderDetailId?: string;
  invoiceDetail?: ProductPurchaseOrderInvoiceViewModel;
  ioTecPayDetail?: ProductPurchaseOrderIoTecPayViewModel;
  /** @format uuid */
  priceBandId?: string;
  priceBand?: ProductPriceBand;
}

export interface ProductPurchaseOrderViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: ProductPurchaseOrderViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export interface ProductSubscription {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  lastUpdated?: string | null;
  isDeleted?: boolean;
  category?: ProductCategory;
  /** @format double */
  creditsBalance?: number;
  /** @format uuid */
  partnerId?: string;
  partner?: Partner;
  /** @format uuid */
  priceBandId?: string;
  priceBand?: ProductPriceBand;
  creditsUsageThreshold?: ProductCreditsUsageThreshold;
  /** @format uuid */
  lock?: string;
}

export interface ProductSubscriptionCreateModel {
  category?: ProductCategory;
  /** @format double */
  balance?: number;
  /** @format uuid */
  partnerId?: string;
  partner?: Partner;
  /** @format uuid */
  productPriceBandId?: string;
  productPriceBand?: ProductPriceBand;
  creditsUsageThreshold?: ProductCreditsUsageThreshold;
  /** @format uuid */
  lock?: string;
}

export interface ProductSubscriptionViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  category?: ProductCategory;
  /** @format double */
  creditsBalance?: number;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format uuid */
  priceBandId?: string;
  priceBand?: ComboModel;
}

export interface ProductTopUpInvoiceCreateModel {
  /** @format uuid */
  partnerId?: string;
  productCategory?: ProductCategory;
  /** @format uuid */
  requestId?: string;
  /** @format date-time */
  dueDate?: string;
  memo?: string | null;
  /** @format double */
  amount?: number;
  /** @format double */
  taxAmount?: number;
  /** @format double */
  credits?: number;
}

export interface ProductTopUpInvoicePayModel {
  /** @format uuid */
  invoiceId?: string;
  /** @format uuid */
  partnerId?: string;
  memo?: string | null;
}

export interface ProductViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  category?: ProductCategory;
  description?: string | null;
}

export interface SmsDynamicReportViewModel {
  /** @format int32 */
  totalSmsMessagesSentOut?: number;
  /** @format int32 */
  totalSmsMessagesDelivered?: number;
  /** @format int32 */
  totalSmsMessagesSentSuccessfully?: number;
  /** @format int32 */
  totalSmsMessagesFailed?: number;
  /** @format double */
  averageSmsMessageRetries?: number;
  /** @format double */
  totalAirtelSmsPercentage?: number;
  /** @format double */
  totalMtnSmsPercentage?: number;
  /** @format int32 */
  totalSuccessfulAirtelSms?: number;
  /** @format int32 */
  totalSuccessfulMtnSms?: number;
  /** @format int32 */
  totalFailedAirtelSms?: number;
  /** @format int32 */
  totalFailedMtnSms?: number;
  hasSubscription?: boolean;
}

export interface SmsMessageCreateModel {
  /** A reference id that can be used to identify the message */
  referenceId?: string | null;
  /**
   * The date and time the message should be sent, leave null to send immediately
   * @format date-time
   */
  scheduledAt?: string | null;
  /**
   * The customer to who this message is being sent
   * @format uuid
   */
  customerId?: string | null;
  /**
   * The bulk request to which this message belongs.
   * This is an optional field
   * @format uuid
   */
  bulkId?: string | null;
  /**
   * The contact list  to which this message belongs.
   * This is an optional field
   * @format uuid
   */
  contactListId?: string | null;
  /**
   * Recipient's phone number
   * @minLength 1
   */
  recipient: string;
  /**
   * The message body
   * @minLength 1
   */
  body: string;
}

export interface SmsMessageMultiCreateModel {
  /** A reference id that can be used to identify the message */
  referenceId?: string | null;
  /**
   * The date and time the message should be sent, leave null to send immediately
   * @format date-time
   */
  scheduledAt?: string | null;
  /**
   * The customer to who this message is being sent
   * @format uuid
   */
  customerId?: string | null;
  /**
   * The bulk request to which this message belongs.
   * This is an optional field
   * @format uuid
   */
  bulkId?: string | null;
  /**
   * The contact list  to which this message belongs.
   * This is an optional field
   * @format uuid
   */
  contactListId?: string | null;
  /** Recipient's these can be phone numbers or contact ids */
  recipients?: string[] | null;
  /** Recipient's customer Group ids */
  recipientCustomerGroups?: string[] | null;
  /**
   * The message body
   * @minLength 1
   */
  body: string;
}

export interface SmsMessageReSendModel {
  messageIds?: string[] | null;
}

export interface SmsMessageSanityRequest {
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string | null;
  /** @format uuid */
  partnerId?: string;
  /** @format uuid */
  bulkId?: string | null;
  /** @format uuid */
  messageId?: string | null;
}

export interface SmsMessageTemplateSendCreateModel {
  /** @minLength 1 */
  recipient: string;
  /** @format uuid */
  partnerId?: string | null;
  /** @format uuid */
  templateId?: string;
  templateMetaData?: Record<string, string>;
  /** @format date-time */
  timeToSend?: string | null;
}

export interface SmsMessageViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  /** @format uuid */
  customerId?: string | null;
  /**
   * The date and time the message should be sent, leave null to send immediately
   * @format date-time
   */
  scheduledAt?: string | null;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  /** @format date-time */
  sentAt?: string | null;
  category?: ProductCategory;
  /** @format uuid */
  productId?: string;
  /** @format uuid */
  bulkId?: string | null;
  status?: MessageStatus;
  statusMessage?: string | null;
  /** @format int32 */
  sendAttempts?: number;
  /** @format int32 */
  maxSendAttempts?: number | null;
  /** @format date-time */
  startedAt?: string | null;
  /** @format int64 */
  runningBalance?: number;
  /** @format date-time */
  processedAt?: string | null;
  channel?: string | null;
  requestedBy?: string | null;
  requestedByData?: ComboModel;
  referenceId?: string | null;
  errorCode?: string | null;
  errorMessage?: string | null;
  body?: string | null;
  sender?: string | null;
  recipient?: string | null;
  recipientName?: string | null;
  /** @format uuid */
  contactListId?: string | null;
  operator?: SmsOperator;
  /** @format int64 */
  characterCount?: number;
  /** @format int64 */
  creditsDeducted?: number;
  /** @format uuid */
  templateId?: string | null;
  /** @format date-time */
  timeToSend?: string | null;
  recipients?: string[] | null;
  smsGateway?: SmsGateway;
}

export interface SmsMessageViewModelPaginatedListViewModel {
  /** @format int32 */
  page?: number;
  /** @format int32 */
  totalPages?: number;
  /** @format int32 */
  total?: number;
  data?: SmsMessageViewModel[] | null;
  hasPreviousPage?: boolean;
  hasNextPage?: boolean;
}

export enum SmsOperator {
  Mtn = "Mtn",
  Airtel = "Airtel",
  Other = "Other",
}

export enum SmsGateway {
  SmsKannel = "SmsKannel",
  EgoSms = "EgoSms",
}

export interface SmsStaticReportViewModel {
  /** @format double */
  creditsLeft?: number;
  successful?: number[] | null;
  delivered?: number[] | null;
  failed?: number[] | null;
  hasSubscription?: boolean;
}

export enum TemplateCategory {
  SMS = "SMS",
  Email = "Email",
}

export interface TemplateCreateModel {
  /** @minLength 1 */
  subject: string;
  /** @minLength 1 */
  body: string;
  category?: TemplateCategory;
  /** @format uuid */
  partnerId?: string;
  isPublic?: boolean;
  isGlobal?: boolean;
}

export interface TemplateEditModel {
  /** @format uuid */
  id?: string;
  body?: string | null;
  subject?: string | null;
  category?: TemplateCategory;
  isPublic?: boolean | null;
  isGlobal?: boolean | null;
}

export interface TemplateTagCreateModel {
  name?: string | null;
  details?: string | null;
}

export interface TemplateTagEditModel {
  /** @format uuid */
  id?: string;
  name?: string | null;
  details?: string | null;
}

export interface TemplateTagViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  name?: string | null;
  details?: string | null;
}

export interface TemplateViewModel {
  /** @format uuid */
  id?: string;
  /** @format date-time */
  createdAt?: string;
  body?: string | null;
  subject?: string | null;
  /** @format uuid */
  partnerId?: string;
  partner?: ComboModel;
  category?: TemplateCategory;
  isPublic?: boolean;
  isGlobal?: boolean;
}

export interface UnauthorizedResult {
  /** @format int32 */
  statusCode?: number;
}

export interface XContactModel {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
}
export enum RoleCategory {
  Analytics = "Analytics",
  Communication = "Communication",
  Customers = "Customers",
  Management = "Management",
}

export enum RoleSubCategory {
  Dashboard = "Dashboard",
  Sms = "Sms",
  SmsTemplates = "SmsTemplates",
  Contacts = "Contacts",
  ContactGroups = "ContactGroups",
  Staff = "Staff",
  Partners = "Partners",
  Settings = "Settings",
  Invoices = "Invoices",
  PriceBands = "PriceBands",
}

export interface SystemRole {
  id?: string | null;
  name?: string | null;
  description?: string | null;
  roleCategory?: RoleCategory;
  roleSubCategory?: RoleSubCategory;
  requiresPrimaryUser?: boolean;
}